import React from "react";
import PropTypes from "prop-types";
import {profileType} from "domain/User/types";
import Modal from "components/Modal";
import ProfileDetails from "components/ProfileDetails";
import UserStatistics from "components/UserStatistics";

const UserDetails = (props) => {
    const {onClose, minWidth, profile, isLoggedIn} = props;

    if (!profile) {
        return null;
    }

    let content = (
        <>
            {minWidth >= 1280 && (
                <button
                    type="button"
                    onClick={onClose}
                    className="sidebar-right__close-wrapper"
                >
                    <span className="sidebar-right__close-text fs-caption hide-desktop-down">
                        Скрыть профиль
                    </span>
                    <span className="close sidebar-right__close"> </span>
                </button>
            )}

            <ProfileDetails {...props} />

            {isLoggedIn && <UserStatistics
                visited_games_count={profile?.visited_games_count}
                organized_games_count={profile?.organized_games_count}
                missed_games_count={profile?.missed_games_count}/>
            }
        </>
    );

    if (minWidth < 1280) {
        content = (
            <Modal
                modificators={[`tablet-page`]}
                title={`Профиль`}
                onClose={onClose}
                closeOnOverlay={false}
                bodyModificators={[`blur-off`]}
            >
                {content}
            </Modal>
        );
    }
    return <div className="sidebar-right__inner">{content}</div>;
};

UserDetails.propTypes = {
    profile: profileType,
    cityName: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    minWidth: PropTypes.number,
    playerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isLoggedIn: PropTypes.bool,
    isCustomFields: PropTypes.array
};

export default UserDetails;
